import { format, parseISO, isToday, isTomorrow, isThisWeek, addDays } from 'date-fns';

export function formatDisplayDate(dateStr: string): string {
  const date = parseISO(dateStr);
  if (isToday(date)) return 'Today';
  if (isTomorrow(date)) return 'Tomorrow';
  if (isThisWeek(date, { weekStartsOn: 0 })) return format(date, 'EEEE');
  return format(date, 'MMMM d, yyyy');
}

export function formatShortDate(dateStr: string): string {
  return format(parseISO(dateStr), 'MMM d');
}

export function formatMonthDay(dateStr: string): string {
  // Works for dates like "1990-07-15" — only shows month/day
  const [, month, day] = dateStr.split('-');
  const d = new Date(2000, parseInt(month) - 1, parseInt(day));
  return format(d, 'MMMM d');
}

export function getNextSabbath(): Date {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sunday, 6 = Saturday
  // Sabbath = Saturday (6)
  const daysUntilSaturday = (6 - dayOfWeek + 7) % 7 || 7;
  return addDays(today, daysUntilSaturday);
}

export function isSameMonthDay(dateStr: string, referenceDate: Date): boolean {
  const [, month, day] = dateStr.split('-');
  return (
    referenceDate.getMonth() + 1 === parseInt(month) &&
    referenceDate.getDate() === parseInt(day)
  );
}

export function birthdayThisYear(birthdayStr: string): string {
  const [, month, day] = birthdayStr.split('-');
  const year = new Date().getFullYear();
  return `${year}-${month}-${day}`;
}

export function formatTime(timeStr?: string): string {
  if (!timeStr) return '';
  const [hours, minutes] = timeStr.split(':');
  const h = parseInt(hours);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const displayHour = h % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
}
